import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AvailabilityMonitor } from '../utilities/availability-monitor';

@Injectable({
	providedIn: 'root'
})
export class AvailabilityGuard  {
	constructor(
		private availabilityMonitor: AvailabilityMonitor,
		private router: Router
	) {
	}

	canActivate(
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		route: ActivatedRouteSnapshot,
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.availabilityMonitor.appAvailability$.pipe(
			take(1),
			map((x) => {
				if(x === 'offline' && state.url !== '/status') {
					return this.router.createUrlTree(['/', 'status'])
				}
				return true;
			})
		);
	}

}
